import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SafeResourceUrlPipe } from './safe-resource-url.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { SafeStylePipe } from './safe-style.pipe';
import { SafeScriptPipe } from './safe-script.pipe';

const pipes = [
  SafeHtmlPipe,
  SafeResourceUrlPipe,
  SafeUrlPipe,
  SafeStylePipe,
  SafeScriptPipe,
];

@NgModule({
  imports: [
  ],
  declarations: [
    ...pipes
  ],
  exports: [
    ...pipes
  ]
})
export class SafePipesModule { }
